/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeEmailSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Email Settings Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const EMAILSETTINGS_EDIT_CONTAINER_LOADED = 'EMAILSETTINGS_EDIT_CONTAINER_LOADED';
export const EMAILSETTINGS_EDIT_CONTAINER_UNLOADED = 'EMAILSETTINGS_EDIT_CONTAINER_UNLOADED';
export const EMAILSETTINGS_EDIT_FORM_LOADED = 'EMAILSETTINGS_EDIT_FORM_LOADED';
export const EMAILSETTINGS_EDIT_FORM_UNLOADED = 'EMAILSETTINGS_EDIT_FORM_UNLOADED';
export const EMAILSETTINGS_UPDATE_FIELD = 'EMAILSETTINGS_UPDATE_FIELD';
export const EMAILSETTINGS_EDIT_FORM_SUBMIT = 'EMAILSETTINGS_EDIT_FORM_SUBMIT';
export const EMAILSETTINGS_EDIT_FORM_CANCEL = 'EMAILSETTINGS_EDIT_FORM_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeEmailSettings.js